if (typeof Swiper !== 'undefined') {
  class InstagramFeed {
    constructor(section) {
      this.section = section;
      this.sliderElement = this.section.querySelector('.instagram-feed__slider');

      if (this.sliderElement) {
        this.initSlider();
      }
    }

    initSlider() {
      const isMobile = window.innerWidth < 990;

      this.swiper = new Swiper(this.sliderElement, {
        slidesPerView: 4,
        spaceBetween: 18,
        loop: false,
        grabCursor: true,
        initialSlide: isMobile ? 1 : 0,
        breakpoints: {
          0: {
            slidesPerView: 'auto',
            spaceBetween: 12,
            centeredSlides: true,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 18,
            centeredSlides: false,
          },
        },
      });
    }
  }

  // Initialize all Instagram Feed sections
  document.addEventListener('DOMContentLoaded', () => {
    const instagramSections = document.querySelectorAll('[data-section-type="w-instagram-feed"]');
    instagramSections.forEach((section) => {
      new InstagramFeed(section);
    });
  });

  // Shopify Theme Editor support
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-section-type="w-instagram-feed"]');
      if (section) {
        new InstagramFeed(section);
      }
    });
  }
}
